import { CalendarDay, PropsGetterConfig } from '@rehookify/datepicker';
import React from 'react';
import { Days } from './date-panel-days';
import { Weekdays } from './date-panel-weekdays';
import { DatePanelSC } from './date-panel.styled';
import { TPropsGetters } from '../../date-time.types';

interface DatePanelProps {
  dayButton: TPropsGetters['dayButton'];
  days: CalendarDay[];
  config?: PropsGetterConfig;
  weekDays: string[];
  weekDaysPrefix: string;
}

const DatePanel: React.FunctionComponent<DatePanelProps> = ({
  dayButton,
  days,
  weekDays,
  weekDaysPrefix,
  config,
}) => {
  return (
    <DatePanelSC>
      <Weekdays weekDays={weekDays} prefix={weekDaysPrefix} />
      <Days days={days} dayButton={dayButton} config={config} />
    </DatePanelSC>
  );
};

export default DatePanel;
